import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { TriageSidebar } from "../Layouts/TriageSidebar";

export class PhysicalExamination extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      Weight: "",
      BP: "",
      T: "",
      Pulse: "",
      Height: "",
      Proteinuria: "",
      edema: "",
      conjuntive: "",
      Breast: "",
      Thorax: "",
      Cardiac: "",
      AbdominalAndKidney: "",
      MemberInferiorAndSuperior: "",
      myParentTrigger: "",
      tablevaluesglobal: {},
      loading: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }
  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();

    // console.log(finalpayload);
      this.setState({

        loading:true
      })
    axios
      .post(
        this.api_url+""+localStorage.getItem('currentModule')+"/physicalexam/general",
        this.state,
        {
          headers: headers,
        }
      )
      .then((response) => {
        console.log(response);
        this.setState({

          loading:false
        })
        if (response.data["status"]) {
          $(".alert-success").show();
          //
          setTimeout(function () {
            window.location.href = "/physical/examination/inspection";
          }, 500);
        }
      })
      .catch((error) => {
        $("#SubmitSuccess").hide();
        $("#SubmitError").show();
        console.log(error);
      });
  };

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };

    const {
      Weight,
      BP,
      T,
      Pulse,
      Height,
      Proteinuria,
      edema,
      conjuntive,
      Breast,
      Thorax,
      Cardiac,
      AbdominalAndKidney,
      MemberInferiorAndSuperior,
      loading
    } = this.state;
    return (
      <div>
        <Headers />
        <TriageSidebar />

        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Physical Examination
                  </p>
                </div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Weight (kg)
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Weight}
                      name="Weight"
                      type="number"
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      BP (mmHg)
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={BP}
                      name="BP"
                      type="number"
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      T
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={T}
                      name="T"
                      type="number"
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Pulse Rate(Minutes)
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Pulse}
                      name="Pulse"
                      type="number"
                    />
                  </div>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Height (Cm)
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Height}
                      name="Height"
                      type="number"
                    />
                  </div>
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Proteinuria (gr)
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Proteinuria}
                      name="Proteinuria"
                      type="number"
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Edema
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={edema}
                      name="edema"
                      type="text"
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Conjuntive
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={conjuntive}
                      name="conjuntive"
                      type="text"
                    />
                  </div>
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Breast
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Breast}
                      name="Breast"
                      type="text"
                    />
                  </div>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Thorax
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Thorax}
                      name="Thorax"
                      type="text"
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Cardiac
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Cardiac}
                      name="Cardiac"
                      type="text"
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Abdominal and Kidney
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={AbdominalAndKidney}
                      name="AbdominalAndKidney"
                      type="text"
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Member inferior/superior
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={MemberInferiorAndSuperior}
                      name="MemberInferiorAndSuperior"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
             
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Physical Examination General Saved
                Successfully.
              </div>
              <div className="row">
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                  {loading ? "Loading" : "Submit"}  
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default PhysicalExamination;
